// #147 — Sentry must initialize before React mounts so errors during
// initial render (auth init etc.) are captured. Do not move this import.
import './instrument'

// #150 — App is imported via `lazy()` so its module-evaluation phase runs
// *inside* React's render call, where Sentry.ErrorBoundary can catch any
// throw from a module-scoped singleton constructor (like the ApiClient
// localStorage crash that hit Galaxy A16 users in #148). A static `import
// App from './App'` would evaluate the App module — and everything it
// transitively imports — BEFORE React.render() runs, putting any throw
// out of the boundary's reach and into window.onerror → blank screen.
import React, { lazy, Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import { Sentry, SentryFallback } from './SentryFallback'

const App = lazy(() => import('./App.tsx'))

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ error, resetError, eventId }) => (
        <SentryFallback error={error} resetError={resetError} eventId={eventId} />
      )}
    >
      <Suspense fallback={null}>
        <App />
      </Suspense>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
)
